import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import getUserInfo from "../../utilities/decodeJwt";
import { API_BASE } from "../../config/api";

const url = `${API_BASE}/user/login`;

const Login = () => {
  const [user, setUser] = useState(null);
  const [data, setData] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = ({ currentTarget: input }) => {
    setData({ ...data, [input.name]: input.value });
  };

  useEffect(() => {
    setUser(getUserInfo());
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data: res } = await axios.post(url, data);
      const { accessToken } = res;
      localStorage.setItem("accessToken", accessToken);
      navigate("/game");
    } catch (err) {
      if (
        err.response &&
        err.response.status >= 400 &&
        err.response.status <= 500
      ) {
        setError(err.response.data.message);
      }
    }
  };

  if (user) {
    navigate("/game");
    return null;
  }

  return (
    <div className="mv-page flex min-h-[calc(100vh-3.5rem)] flex-col items-center justify-center px-4 py-16">
      <div className="mv-card w-full max-w-md p-8 md:p-10">
        <h1 className="mv-heading text-center text-2xl md:text-3xl">Log in</h1>

        <form className="mt-8 space-y-5" onSubmit={handleSubmit}>
          <div>
            <label className="mv-label" htmlFor="login-username">
              Username
            </label>
            <input
              id="login-username"
              className="mv-input"
              type="text"
              name="username"
              autoComplete="username"
              placeholder="Username"
              onChange={handleChange}
            />
          </div>
          <div>
            <label className="mv-label" htmlFor="login-password">
              Password
            </label>
            <input
              id="login-password"
              className="mv-input"
              type="password"
              name="password"
              autoComplete="current-password"
              placeholder="Password"
              onChange={handleChange}
            />
          </div>
          {error && <p className="text-sm text-rose-400">{error}</p>}
          <button type="submit" className="mv-btn-primary w-full py-3">
            Log in
          </button>
        </form>

        <p className="mt-8 text-center text-sm text-slate-500">
          Need an account?{" "}
          <Link
            to="/signup"
            className="font-semibold text-cinema-accent hover:text-cinema-accent-hover"
          >
            Sign up
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
